import React, { Component, Fragment } from 'react';
import { createPortal } from 'react-dom';
import Panel from '@/components/Panel';
import { PlusCircleOutlined } from '@ant-design/icons';
import { Select, Divider, Checkbox } from 'antd';
import { getPanelMaxWidth, getPanelWidth, getPanelMaxHeight } from '@/services/helper/panelSizeHelper';
import projectDesigns from '@/services/helper/projectDesigns';
import { getAllCascadeComponents } from '../../../../services/Cascade/helper/setupData';
import { IGNORE } from '../../../../constants/componentType';
import AddConnection from './addConnection';
import componentSetting from '../../../../services/Cascade/helper/compSettingHelper';
import { IMPEDANCE_DIE, IMPEDANCE_INTERPOSER, IMPEDANCE_PACKAGE_FILE } from '../../../../services/Cascade/constants';
import designConstructor from '../../../../services/helper/designConstructor';
import preLayoutData from '../../../../services/Cascade/prelayout/preLayoutData';
import { LAYOUT } from '../../../../constants/designType';
import { splitArrayToArrays } from '../../../../services/helper/arrayHelper';
import { AC } from '../../../../constants/treeConstants';
import auroraDBJson from '../../../../services/Designs/auroraDbData';

const TITLE = 'Layout/Model';
const optionList = [
  {
    title: "PCB",
    label: "PCB Layout",
    options: []
  },
  {
    title: "Package",
    label: "Package Layout",
    options: []
  },
  {
    title: "Model",
    label: "Model",
    options: [
      { value: IMPEDANCE_DIE, label: "Die" },
      { value: IMPEDANCE_INTERPOSER, label: "Package-Die Interposer" },
      { value: IMPEDANCE_PACKAGE_FILE, label: "Package Model" }
    ]
  }
]
const PCB_INDEX = 0, PKG_INDEX = 1, MODEL_INDEX = 2, DIE_INDEX = 0, INTERPOSER_INDEX = 1, PKG_MODEL_INDEX = 2;
class PCBPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maxWidth: 800,
      maxHeight: 1000,
      pcbId: "",
      title: TITLE,
      pcbList: [],
      packageList: [],
      connectors: [],
      connComps: [],
      contentWidth: 600,
      contentHeight: 500,
      drawStatus: false,
      asInterposer: false,
      asPassiveBoard: false
    };
    this.dialogRoot = document.getElementById('root');
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    const contentRoot = document.getElementById('cascade-net-connection-content') || {}
    this.setState({
      maxWidth: getPanelMaxWidth(offset, 800),
      maxHeight: getPanelMaxHeight(offset, 1000),
      contentWidth: contentRoot.offsetWidth || 600,
      contentHeight: contentRoot.offsetHeight || 500,
      drawStatus: !this.state.drawStatus
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getLayoutList();
  }

  closeModal = () => {
    const { connectors, pcbId, asInterposer, asPassiveBoard } = this.state;
    if (pcbId === IMPEDANCE_DIE) {
      this.props.createDie()
    } else if (pcbId === IMPEDANCE_INTERPOSER) {
      this.props.saveHasInterposer(true)
    } else if (pcbId === IMPEDANCE_PACKAGE_FILE) {
      this.props.createPackageFile(pcbId)
    } else if (pcbId) {
      this.props.createNewLayout(pcbId, connectors, asInterposer, asPassiveBoard)
    }
    this.props.closeModal(false)
  }

  PCBSelect = (pcbId) => {
    const title = TITLE;
    this.setState({
      pcbId,
      title,
      connectors: []
    }, async () => {
      const { pcbList } = this.state;
      if (pcbList.some(item => item.id === pcbId)) {
        const connComps = await this.getConnectionComps(pcbId);
        this.setState({ connComps })
      }
    })
  }

  getConnectionComps = async (pcbId) => {
    const isPreLayout = designConstructor.isPreLayout(pcbId);
    if (isPreLayout) {
      const preData = await preLayoutData.getPreLayout(pcbId);
      if (preData) {
        const { content } = preData;
        const { components } = content;
        return components
      }
      return []
    }
    const setting = componentSetting.getSetting({ designId: pcbId });
    await auroraDBJson.getAuroraJson(pcbId, setting);
    const { pcbList } = this.state;
    const isPCB = pcbList.find(item => item.id === pcbId) ? true : false;
    if (isPCB) {
      const components = getAllCascadeComponents({ pcbId });
      const connComps = [...components.values()].filter(comp => comp.type === IGNORE).sort((a, b) => a.name > b.name ? 1 : -1) || []
      return connComps
    }
    return []
  }

  getLayoutList = () => {
    const { projectId } = this.props;
    const pcbList = projectDesigns.getAvailablePostLayouts(projectId);
    const packageList = projectDesigns.getAvailablePackages(projectId);
    const preLayoutList = projectDesigns.getAvailablePreLayouts(projectId).filter(design => design && design.content && (!design.content.electric || design.content.electric === AC));
    const preLayoutRule = (item) => {
      return item.type === LAYOUT ? true : false;
    }
    const { trueArray: preLayoutPCBs, falseArray: preLayoutPackages } = splitArrayToArrays({ array: preLayoutList, rule: preLayoutRule })
    this.setState({
      pcbList: [...pcbList, ...preLayoutPCBs],
      packageList: [...packageList, ...preLayoutPackages],
    })
  }

  addConnector = () => {
    const { connectors, pcbId } = this.state;
    this.setState({
      connectors: [
        ...connectors,
        { name: "", designId: pcbId, netShip: [{ connector: "", designId: "", nets: [] }] }
      ]
    })
  }

  addConnectorShip = (index) => {
    const { connectors } = this.state;
    let _connectors = [...connectors];
    _connectors[index].netShip.push({ connector: "", designId: "", nets: [] });
    this.setState({
      connectors: _connectors
    })
  }

  saveConnectorInfo = (index, key, value, resize) => {
    const { connectors } = this.state;
    let _connectors = [...connectors];
    _connectors[index][key] = value;
    this.setState({
      connectors: _connectors
    }, () => {
      if (resize) {
        this.resize()
      }
    })
  }

  timeResize = () => {
    setTimeout(() => {
      this.resize()
    }, 1000)
  }

  setInterposer = (e) => {
    const value = e.target.checked
    this.setState({
      asInterposer: value,
      asPassiveBoard: value ? false : this.state.asPassiveBoard
    })
  }

  setPassiveBoard = (e) => {
    const value = e.target.checked
    this.setState({
      asPassiveBoard: value,
      asInterposer: value ? false : this.state.asInterposer
    })
  }

  couldSetInterposerOrPassive = () => {
    const { pcbId, pcbList } = this.state;
    const { designIds } = this.props;
    if (pcbList.find(pcb => pcb.id === pcbId) && !designIds.includes(pcbId)) {
      return true;
    }
    return false;
  }

  pcbSelectOptions = () => {
    const { designIds, hasDie, hasInterposer, targetDie = [] } = this.props;
    const { pcbList, packageList } = this.state;
    const hasPackage = [...packageList, { id: IMPEDANCE_PACKAGE_FILE }].find(item => designIds.includes(item.id));
    let options = JSON.parse(JSON.stringify(optionList));
    options[PCB_INDEX].options = pcbList.map(pcb => ({ value: pcb.id, label: pcb.name, disabled: designIds.includes(pcb.id) }))

    options[PKG_INDEX].options = packageList.map(pkg => ({ value: pkg.id, label: pkg.name, disabled: hasPackage }))

    options[MODEL_INDEX].options[DIE_INDEX].title = hasPackage ? IMPEDANCE_DIE : 'Please add package first.'
    options[MODEL_INDEX].options[DIE_INDEX].disabled = !hasPackage || hasDie;

    options[MODEL_INDEX].options[INTERPOSER_INDEX].title = hasPackage ? (targetDie.length > 1 ? 'Multi-Die does not support interposer' : 'Interposer') : 'Please add die first.'
    options[MODEL_INDEX].options[INTERPOSER_INDEX].disabled = !hasPackage || !hasDie || hasInterposer || targetDie.length > 1;

    options[MODEL_INDEX].options[PKG_MODEL_INDEX].disabled = hasPackage
    return options;
  }

  pcbSelectRender = () => {
    const { pcbId, title, asInterposer, asPassiveBoard } = this.state;
    const options = this.pcbSelectOptions()
    const setInterposerOrPassive = this.couldSetInterposerOrPassive();
    return <div className="cascade-add-pcb-interposer-content">
      <span className="font-bold cascade-setup-title-color-only">{title}</span>
      <Select
        value={pcbId}
        onChange={this.PCBSelect}
        getPopupContainer={(() => document.getElementById('root'))}
        showSearch={true}
        className={`pcb-select ${setInterposerOrPassive ? 'set-interposer' : ''}`}
        popupClassName="aurora-select-dropdown"
        options={options}
      />
      {
        setInterposerOrPassive ? <div className="cascade-set-interposer-layout">
          <Checkbox checked={asInterposer} onChange={e => this.setInterposer(e)} >Set as Interposer</Checkbox>
          <Checkbox checked={asPassiveBoard} onChange={e => this.setPassiveBoard(e)} >Set as Passive Board</Checkbox>
        </div> : null
      }
    </div>
  }

  connectorRender = () => {
    const { connectors, connComps, pcbList, pcbId, packageList, contentWidth, contentHeight, drawStatus, asInterposer, asPassiveBoard } = this.state;
    const { designIds, designTypes } = this.props;
    const isPackage = [...packageList, IMPEDANCE_PACKAGE_FILE].find(item => pcbId === item.id);
    if (isPackage || !pcbId || [IMPEDANCE_INTERPOSER, IMPEDANCE_DIE, IMPEDANCE_PACKAGE_FILE].includes(pcbId)) {
      return null
    }
    return (
      <Fragment>
        <Divider />
        <div className="cascade-add-pcb-content">
          <span className="font-bold cascade-setup-title-color">Connectors <PlusCircleOutlined className='cascade-imp-icon' onClick={() => this.addConnector()} /></span>
        </div>
        {
          connectors.map((conn, index) => {
            return <div key={index} className="cascade-setup-border cascade-add-pcb-connector-content">
              <AddConnection
                connector={conn}
                designTypes={designTypes}
                index={index}
                saveConnectorInfo={this.saveConnectorInfo}
                addConnectorShip={this.addConnectorShip}
                deleteShip={this.props.deleteShip}
                connComps={connComps}
                designId={pcbId}
                pcbList={pcbList.filter(item => item.id !== pcbId)}
                getConnectionComps={this.getConnectionComps}
                contentWidth={contentWidth}
                contentHeight={contentHeight}
                drawStatus={drawStatus}
                designIds={designIds}
                resize={this.resize}
                asInterposer={asInterposer}
                asPassiveBoard={asPassiveBoard}
                getAutoConnectionNet={this.props.getAutoConnectionNet}
              />
            </div>
          })
        }
      </Fragment>
    );
  }

  render() {
    const { maxWidth, maxHeight } = this.state;
    const content = (
      <Fragment>
        <Panel
          className='cascade-add-pcb-panel'
          title={`Add ${TITLE}`}
          onCancel={this.closeModal}
          zIndex={2000}
          width={getPanelWidth(maxWidth, { defaultWidth: 800 })}
          maxHeight={maxHeight}
          position='panel-center'
          draggable
          minHeight={150}
          minWidth={200}
          defaultTop={100}
          resizeEnd={this.timeResize}
        >
          {this.pcbSelectRender()}
          {this.connectorRender()}
        </Panel>
        <div id="cascade-add-connection-dialog"></div>
      </Fragment>
    )
    return createPortal(content, this.dialogRoot);
  }
}


export default PCBPanel;
